/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Company with expiring subscription
 * @export
 * @interface WebApiAdminDtoExpiringCompanyDto
 */
export interface WebApiAdminDtoExpiringCompanyDto {
    /**
     * Company ID
     * @type {number}
     * @memberof WebApiAdminDtoExpiringCompanyDto
     */
    companyId?: number;
    /**
     * Company name
     * @type {string}
     * @memberof WebApiAdminDtoExpiringCompanyDto
     */
    companyName?: string | null;
    /**
     * Subscription level
     * @type {string}
     * @memberof WebApiAdminDtoExpiringCompanyDto
     */
    subscriptionLevel?: string | null;
    /**
     * Next renewal date
     * @type {Date}
     * @memberof WebApiAdminDtoExpiringCompanyDto
     */
    nextSubscriptionRenewalDate?: Date | null;
    /**
     * Days until expiration
     * @type {number}
     * @memberof WebApiAdminDtoExpiringCompanyDto
     */
    daysUntilExpiration?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoExpiringCompanyDto interface.
 */
export function instanceOfWebApiAdminDtoExpiringCompanyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoExpiringCompanyDtoFromJSON(json: any): WebApiAdminDtoExpiringCompanyDto {
    return WebApiAdminDtoExpiringCompanyDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoExpiringCompanyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoExpiringCompanyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'subscriptionLevel': !exists(json, 'subscriptionLevel') ? undefined : json['subscriptionLevel'],
        'nextSubscriptionRenewalDate': !exists(json, 'nextSubscriptionRenewalDate') ? undefined : (json['nextSubscriptionRenewalDate'] === null ? null : new Date(json['nextSubscriptionRenewalDate'])),
        'daysUntilExpiration': !exists(json, 'daysUntilExpiration') ? undefined : json['daysUntilExpiration'],
    };
}

export function WebApiAdminDtoExpiringCompanyDtoToJSON(value?: WebApiAdminDtoExpiringCompanyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'companyName': value.companyName,
        'subscriptionLevel': value.subscriptionLevel,
        'nextSubscriptionRenewalDate': value.nextSubscriptionRenewalDate === undefined ? undefined : (value.nextSubscriptionRenewalDate === null ? null : value.nextSubscriptionRenewalDate.toISOString()),
        'daysUntilExpiration': value.daysUntilExpiration,
    };
}

